import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';

import { GetPackagesResult } from 'api/hooks/public/useGetPackages';

import Package from './components/Package';

const Packages = (props: { packages?: GetPackagesResult[] }): JSX.Element => {
  return (
    <Box id="packages">
      <Box marginBottom={4}>
        <Typography variant={'h2'} align={'center'} gutterBottom sx={{ fontWeight: 700 }}>
          Course Packages
        </Typography>
        {/* <Typography
          variant={'h6'}
          component={'p'}
          color={'text.secondary'}
          align={'center'}
        >
          Some sort of subtitle can go here if needed.
        </Typography> */}
      </Box>
      <Grid container spacing={4} justifyContent="center">
        {props.packages?.map((item) => (
          <Package pkg={item} key={item.id} />
        ))}
      </Grid>
    </Box>
  );
};

export default Packages;
